import Header, { HeaderModifier } from 'components/header';
import { useTranslation } from 'react-i18next';
import BalanceCheckLeftTableWithReactQueryProvider, { BalanceCheckLeftTableDef } from 'components/table/balancecheck/balanceCheckLeftTable';
import { LocationHistoryMismatch } from 'components/table/balanceTable';
import BalanceCheckTableFilters from 'components/table/filters/balanceCheckTableFilters';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TableDataRes } from 'components/table/base/tableBaseApi';
import { TooltipAlignEnum } from 'components/tooltip';

export interface BalanceCheckTableProps {
  data: boolean;//use cached data for left table

  filters: string;
  setFilters: (value: string) => void;

  globalFilter: string;

  warningsUpdate: boolean | undefined;
  setWarningsUpdate: (value: boolean | undefined) => void;

  showReportedBalances: boolean | undefined;
  setShowReportedBalances: (value: boolean | undefined) => void;

  userCurrencyMismatch: boolean | undefined;
  setUserCurrencyMismatch: (value: boolean | undefined) => void;

  showSpinners: boolean;
  setShowSpinners: (value: boolean) => void;

  isFetching: boolean;
  setIsFetching: (value: boolean) => void;

  onRightTableLoaded: (value: TableDataRes<any, any>) => void;
  onLeftTableLoaded: (value: TableDataRes<BalanceCheckLeftTableDef, any>) => void;

  goToDetailSideEffect: () => void;

  routeName: string;
}

function BalanceCheckComponent() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const [filters, setFilters] = useState('');

  //for table local search
  const [globalFilter, setGlobalFilter] = useState('');


  const [warningsUpdate, setWarningsUpdate] = useState<boolean>(false);
  const [showReportedBalances, setShowReportedBalances] = useState<boolean>(false);
  const [userCurrencyMismatch, setUserCurrencyMismatch] = useState<boolean | undefined>(undefined);
  const [showSpinners, setShowSpinners] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  return (
    <>
      <div className="ct_padding">
        <div className="ct_section _oldView">
          <div className="ct_section-inner">
            <div className="ct_section-main">
              <div className="ct_overviewHeader">
                <div className="ct_overviewHeader-main">
                  <Header
                    headline={t('Balance Check', { ns: 'overview' })}
                    desc={t('This report provides a comprehensive overview of your current balances categorized by exchange and wallet.', { ns: 'overview' })}
                    desc2={t('It meticulously compares the imported balances with the figures reported by your exchanges and blockchains, ensuring accuracy and transparency in tracking your crypto portfolio.', { ns: 'overview' })}
                    modifiers={[HeaderModifier.OLD, HeaderModifier.OLD_MARGIN]}
                  />
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="ct_section _oldView">
          <div className="ct_section-inner">
            <div className="ct_section-main">
                <div className="ct_overviewHeader-fullSide">
                <BalanceCheckTableFilters
                    useLocalSearch={true}
                    ignoreSmallMismatchesProp={false}
                    ignoreUserCurrencyMismatchesProp={
                      (location.state as LocationHistoryMismatch !== undefined)
                      && (location.state as LocationHistoryMismatch !== null)
                      && ((location.state as LocationHistoryMismatch).dataCurrency !== undefined)
                      && ((location.state as LocationHistoryMismatch).dataCurrency !== null)
                        ? (location.state as LocationHistoryMismatch).dataCurrency! : true
                    }
                    onSmallMismatchUpdate={() => {}}
                    onUserCurrencyMismatchUpdate={(value: boolean) => setUserCurrencyMismatch(value)}
                    onWarningsUpdate={(value: boolean) => {
                        setWarningsUpdate(value);
                    }}
                    onShowReportedBalanceUpdate={(value: boolean) => {
                        setShowReportedBalances(value);
                    }}
                    showWarningsProp={warningsUpdate}
                    showReportedBalancesProp={showReportedBalances}
                    onFitlerCB={(value: string) => {
                        setFilters(value);
                      }
                    }
                    onGlobalFilterUpdate={(value: string) => {
                        setGlobalFilter(value);
                      }
                    }
                    disabled={showSpinners}
                    leftAlignedSearch={false}
                    tooltipAlignment={TooltipAlignEnum.RIGHT}
                  />
                  <BalanceCheckLeftTableWithReactQueryProvider
                  data={(location.state as LocationHistoryMismatch !== undefined)
                    && (location.state as LocationHistoryMismatch !== null)
                    && ((location.state as LocationHistoryMismatch).tableChanged !== undefined)
                    && ((location.state as LocationHistoryMismatch).tableChanged !== null)
                      ? (location.state as LocationHistoryMismatch).tableChanged! : false}
                  filters={filters}
                  globalFilter={globalFilter}
                  setFilters={(value) => setFilters(value)}
                  warningsUpdate={warningsUpdate}
                  setWarningsUpdate={ value => setWarningsUpdate(value) }
                  showReportedBalances={ showReportedBalances }
                  setShowReportedBalances={ value => setShowReportedBalances(value) }
                  userCurrencyMismatch={ userCurrencyMismatch }
                  setUserCurrencyMismatch={ value => setUserCurrencyMismatch(value) }
                  showSpinners={ showSpinners }
                  setShowSpinners={value => setShowSpinners(value)}
                  isFetching={ isFetching }
                  setIsFetching={value => setIsFetching(value)}
                  onRightTableLoaded={() => {}}
                  onLeftTableLoaded={() => {}}
                  goToDetailSideEffect={() => {}}
                  routeName={'balancecheck'}
                  />
                </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default BalanceCheckComponent;
